import ResendResetPassword from './ResendResetPassword';

export default ResendResetPassword;
